import { useEffect } from 'react';
import { LandingNav } from '../../components/landing-nav';
import { LandingFooter } from '../../components/landing-footer';

interface MarketingLayoutProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export function MarketingLayout({ title, subtitle, children }: MarketingLayoutProps) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, []);

  return (
    <div className="min-h-dvh flex flex-col bg-background">
      <LandingNav />

      {/* Page header — padding-top clears the fixed nav */}
      <header className="pt-28 md:pt-36 pb-10 md:pb-14 text-center px-4">
        <h1 className="font-serif text-4xl md:text-5xl font-bold tracking-tight text-primary">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-base md:text-lg text-muted-foreground max-w-xl mx-auto">
            {subtitle}
          </p>
        )}
      </header>

      {/* Page body */}
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 pb-16 md:pb-24">
        {children}
      </main>

      <LandingFooter />
    </div>
  );
}
